/** Settings -> Planning's workflow block (planning Phase 3, plan P3-3b D-161). Spread into settings-en.ts. */
export default {
  title: 'Referrals, numbers and conditions',
  intro:
    'Used by the KM procedure: the agencies a case is circulated to, how decision letters are numbered, the council code, the local plan and the conditions library.',
  agencies: 'Referral agencies',
  agenciesHint:
    "Council departments answer in gisify through their group; outside agencies' replies are keyed in by the OSC unit.",
  agencyRow: 'Agency {{index}}',
  agencyCode: 'Code',
  agencyKind: 'Kind',
  agencyNameIn: 'Name ({{locale}})',
  agencyGroup: 'Department group',
  noGroup: 'No group yet',
  addAgency: 'Add an agency',
  remove: 'Remove',
  numbering: 'Decision numbers',
  numberingHint:
    'Write {seq} where the running number goes ({seq:4} pads it to four digits), and {yyyy} or {yy} for the year if you want it.',
  preview: 'The next number would look like {{example}}.',
  schemes: {
    borang_c1: 'Form C1 (planning permission)',
    kelulusan_bangunan: 'Building plan approval',
  },
  pbtId: 'Council code (PBT)',
  pbtIdHint: 'The code national exports use for this council: letters, digits, hyphens and underscores, up to 32.',
  localPlanInForce: 'A local plan is in force',
  localPlanInForceHint:
    'When none is, a KM case needs a neighbour notice before its recommendation. Registration starts from this answer.',
  library: 'Conditions library',
  libraryHint: 'Conditions officers can add to a decision in one step.',
  conditionRow: 'Condition {{index}}',
  libraryCode: 'Code',
  libraryPCode: 'Compliance stage',
  libraryText: 'Condition',
  addCondition: 'Add a condition',
  choose: 'Choose…',
  errors: {
    agencyCode: 'Use lower-case letters, digits, hyphens or underscores, starting with a letter or digit, at most 40.',
    agencyRepeated: 'Another agency already uses this code.',
    agencyLabel: 'Give a name in at least one language, at most 200 characters each.',
    externalGroup: 'An outside agency has no department group.',
    agenciesMax: 'At most {{max}} agencies.',
    pbtId: 'Use letters, digits, hyphens or underscores, at most 32.',
    libraryCode:
      'Start with a letter or digit, then letters, digits, dots, brackets, hyphens or underscores, at most 64.',
    libraryRepeated: 'Another condition already uses this code.',
    libraryPCode: 'Give the compliance stage.',
    libraryText: 'Write the condition, at most 2000 characters.',
    libraryTextCharacters: 'Remove the hidden control characters (for example a pasted line break) from the condition.',
    libraryMax: 'At most {{max}} conditions.',
  },
  formatIssues: {
    empty: 'Write a format.',
    too_long: 'Too long: a number must stay within 64 characters.',
    unsafe: 'Remove the control characters.',
    spaces: 'Remove the spaces at the start or the end.',
    no_sequence: 'Add {seq} or {seq:N} for the running number.',
    two_sequences: 'Use the running number only once.',
    stray_brace: 'Braces are only for {seq}, {seq:N}, {yyyy} and {yy}.',
  },
} as const
